package dev.danko.roblox_craft_ai.uikit.components

import dev.danko.roblox_craft_ai.uikit.config.BackendEndpoint
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlinx.coroutines.withTimeoutOrNull
import kotlin.coroutines.resume

// A self-contained function called with arguments: a js("…") string must not name Kotlin locals.
private val renderThumbnailFunction: dynamic = js("""
    (function(url, done) {
        var T = window.THREE;
        var canvas = document.createElement('canvas');
        canvas.width = 320; canvas.height = 200;
        var renderer;
        try { renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: false, preserveDrawingBuffer: true }); }
        catch (e) { done(null); return; }
        renderer.setClearColor(0x161a22, 1);
        if (T.sRGBEncoding) renderer.outputEncoding = T.sRGBEncoding;
        var scene = new T.Scene();
        scene.add(new T.HemisphereLight(0xffffff, 0x334155, 1.0));
        var sun = new T.DirectionalLight(0xffffff, 0.9);
        sun.position.set(3, 5, -4);
        scene.add(sun);
        var loader = new T.GLTFLoader();
        loader.load(url, function(gltf) { try {
            var model = gltf.scene;
            scene.add(model);
            // One "new" per statement: the Kotlin/JS printer drops it in "new A().method()".
            var box = new T.Box3();
            box.setFromObject(model);
            var size = new T.Vector3();
            box.getSize(size);
            var centre = new T.Vector3();
            box.getCenter(centre);
            var radius = Math.max(size.x, size.y, size.z) * 0.62 || 1;
            var camera = new T.PerspectiveCamera(35, 320 / 200, radius / 100, radius * 100);
            // Three-quarter view from the front (Roblox models face -Z).
            camera.position.set(centre.x + radius * 1.7, centre.y + radius * 0.9, centre.z - radius * 2.4);
            camera.lookAt(centre);
            renderer.render(scene, camera);
            var picture = canvas.toDataURL('image/png');
            renderer.dispose();
            done(picture);
        } catch (e) { renderer.dispose(); done(null); } }, undefined, function() { renderer.dispose(); done(null); });
    })
""")

/** A PNG picture (data URL) of the model at [url], drawn in the browser; null when it cannot be drawn. */
suspend fun renderModelThumbnail(url: String): String? = withTimeoutOrNull(20_000) {
    suspendCancellableCoroutine { continuation ->
        ensureThreeJsLoaded({
            try {
                renderThumbnailFunction(BackendEndpoint.resolveAssetUrl(url), { picture: String? ->
                    if (continuation.isActive) continuation.resume(picture)
                })
            } catch (error: Throwable) {
                if (continuation.isActive) continuation.resume(null)
            }
        })
    }
}
